var utils = {

  outLogin() {
    this.$store.state.ifLogin = false;
    this.$store.state.ifYg = false;
    this.$store.commit("likeweb");
    localStorage.removeItem("jwt");
    
    this.value = false;
    this.siteError = 0;
    this.siteWarning = 0;
    this.siteSuccess = 0;
    var toURL = 'https://i.desmix.com/sso/auth/logout?from=nx_monitor'
    var redirect = encodeURIComponent(process.env.SSO_REDIRECT)
    location.href = toURL + `&redirect=${redirect}`
  },
  setUserInfo(d) {
    console.log('setUserInfo', d)
    if (d.code === 0) {
      let data = d.data
      // this.$store.state.ifYg = true
      this.$store.state.ifYg = false
      // data.ifstaff === 1 ? this.$store.state.ifYg = true : this.$store.state.ifYg = false
      this.$store.state.ifLogin = true
      this.$store.state.nickName = data.username
      this.$store.state.userImage = require("../assets/touxiang.jpg");
      this.$store.state.userName = data.username
      // this.$store.state.wxAppData = data.wxAppData.unionid;
      this.$store.state.userApple = data.userApple;

      if (data.likeweb == null) {
        this.$store.state.likeweb = [0];
      }
      if (data.likeweb) {
        this.$store.state.likeweb = data.likeweb.split(",").map(Number);
      }
      if (data.userSite == null) {
        this.$store.state.userSite = [0];
      }
      if (data.userSite) {
        this.$store.state.userSite = data.userSite.split(",").map(Number);
      }
    }
  }


  // outLogin() {
  //   this.$store.state.ifLogin = false;
  //   this.$store.state.ifYg = false;
  //   this.$store.commit("likeweb");
  //   localStorage.removeItem("jwt");
    
  //   this.value = false;
  //   this.siteError = 0;
  //   this.siteWarning = 0;
  //   this.siteSuccess = 0;
  //   var toURL = process.env.SSO_API
  //   var redirect = encodeURIComponent(process.env.SSO_REDIRECT)
  //   location.href = toURL + '?logout=1' + `&redirect=${redirect}`
  // },
  // setUserInfo(data) {
  //   if (data.hasLogin) {
  //     console.log('setUserInfo', data);
  //     data.ifstaff === 1 ? this.$store.state.ifYg = true : this.$store.state.ifYg = false
  //     this.$store.state.ifLogin = true
  //     this.$store.state.nickName = data.nickname;
  //     this.$store.state.userImage = data.headimgurl;
  //     this.$store.state.userName = data.userName;
  //     this.$store.state.wxAppData = data.wxAppData.unionid;
  //     this.$store.state.userApple = data.userApple;
  //     if (!data.headimgurl) {
  //       this.$store.state.userImage = require("../assets/touxiang.jpg");
  //     }
  //     if (data.likeWeb == null) {
  //       this.$store.state.likeweb = [0];
  //     }
  //     if (data.likeWeb) {
  //       this.$store.state.likeweb = data.likeWeb.split(",").map(Number);
  //     }
  //     if (data.userSite == null) {
  //       this.$store.state.userSite = [0];
  //     }
  //     if (data.userSite) {
  //       this.$store.state.userSite = data.userSite.split(",").map(Number);
  //     }
  //   }
  // }
  
}

module.exports = utils


// WEBPACK FOOTER //
// ./src/js/utils.js